import { getIsOnline } from '@/lib/onlineStatus';
import { InvoiceServiceTab } from './invoiceServiceTab';

/**
 * Consecutive invoice number from the DB when online.
 * If the device is offline or the assign call fails, print with the tab id.
 */
export async function resolvePrintedInvoiceNumber(
  forPreview: boolean,
  tab: { id: string },
  organizationId: string,
): Promise<string> {
  if (forPreview) return 'PREVIEW';
  if (!getIsOnline()) return tab.id.slice(-8);

  try {
    return await InvoiceServiceTab.assignInvoiceNumberToTab(tab.id, organizationId);
  } catch (error) {
    console.warn('Could not assign invoice number, using local fallback', error);
    return tab.id.slice(-8);
  }
}
